import React, { useState } from "react";
import { FloatingContainer } from "../../../components/wrappers/floatingContainer";
import { Flex, Image, Box } from "rebass/styled-components";
import { Title1, Headline } from "../../../components/text";
import { PostContents } from "../clipOptions/postContents";
import { ShareContents } from "../../../MVVM/Components/ShareOptions";
import { Divider } from "../../atoms/divider";
import { useInterval } from "../../../hooks";
import styled from "styled-components";
import Lottie from "lottie-react";
import saveEdit from "../../../animations/saveEdit.json";
import { useGetUser } from "../../../userStore";

const StyledThumb = styled(Image)`
  display: flex;
  position: absolute;
  top: -130px;
  object-fit: contain;
  width: 100%;
  overflow: hidden;
  box-shadow: 0 0 20px 20px rgb(0 0 0 / 15%);
  color: #fff;
  max-width: 410px;
  height: auto;
  border-radius: 10px;
  @media (max-width: ${(props) => props.theme.breaks.narrow}) {
    max-width: 280px;
    top: -70px;
  }
`;

const lottieStyle = {
  height: 80,
};

const StyledBox = styled(Box)`
  display: flex;
  position: absolute;
  top: -130px;
  background-color: ${(props) => {
    return props.theme.colors.ned;
  }};
  width: 410px;
  height: 230px;
  border-radius: 10px;
  @media (max-width: ${(props) => props.theme.breaks.narrow}) {
    width: 280px;
    height: 157px;
    top: -70px;
  }
`;

const isTouchDevice = () =>
  "ontouchstart" in window ||
  navigator.maxTouchPoints > 0 ||
  navigator.msMaxTouchPoints > 0;

export function ShareModal({ clip, aspectRatio = "9:16", isMobile, ...props }) {
  const user = useGetUser();
  const clipUserId = clip?.user?._id ? clip?.user?._id : clip?.user;
  const isOwnClip = user ? clipUserId === user?._id : false;
  const FIFTY_MB = 50 * 1024 * 1000;
  const mobileData = clip.mobile?.find((x) => x.aspectRatio === aspectRatio);
  let hideShareAPI = true;
  const [imageReady, setImageReady] = useState(!clip.fromEdit);
  const [imageSource, setImageSource] = useState(
    `${process.env.REACT_APP_S3_CLIP_BUCKET}/${clip.clipSnapshot}`
  );
  let requestCount = 0;
  useInterval(() => {
    if (requestCount > 20 && !imageReady) {
      setImageSource(
        `${process.env.REACT_APP_S3_CLIP_BUCKET}/${clip.clipImageThumb}`
      );
      setImageReady(true);
    }

    if (clip.fromEdit || imageReady) {
      async function checkData() {
        let url = imageSource;

        try {
          let data = await fetch(url, {
            method: "HEAD",
          });
          requestCount += 1;
          if (data.status === 200) {
            setImageReady(true);
          }
        } catch (e) {
          console.log(e);
        }
      }
      if (!imageReady) {
        checkData();
      }
    }
  }, 1000);
  if (
    (!mobileData && clip.clipSizeBytes <= FIFTY_MB) ||
    (mobileData && mobileData.clipSizeBytes <= FIFTY_MB)
  ) {
    hideShareAPI = false;
  }

  return (
    <>
      <FloatingContainer maxWidth="500px" maxHeight="700px">
        <Flex mb={10} position="relative" justifyContent="center">
          {imageReady ? (
            <StyledThumb src={imageSource} />
          ) : (
            <StyledBox justifyContent="center" alignItems={"center"}>
              <Flex flexDirection="column">
                <Lottie
                  animationData={saveEdit}
                  style={lottieStyle}
                  loop={true}
                />
                <Headline mt={3} color="chalk">
                  Updating your clip thumbnail
                </Headline>
              </Flex>
            </StyledBox>
          )}
        </Flex>
        <Flex
          flexDirection="column"
          alignItems="stretch"
          justifyContent="flex-start"
        >
          {isTouchDevice() && !hideShareAPI && isOwnClip ? (
            <>
              <Title1 textAlign="center" mb={5}>
                Publish your clip
              </Title1>

              <PostContents
                clip={clip}
                aspectRatio={aspectRatio}
                isMobile={isMobile}
              />

              {!isMobile && <Divider>or</Divider>}
            </>
          ) : (
            <></>
          )}
          {!isMobile && (
            <>
              <Flex
                flexDirection="column"
                alignItems="center"
                justifyContent="space-between"
                name="clip-share-modal"
              >
                <Title1 mb={5}>Share with your friends</Title1>
                <ShareContents clip={clip}></ShareContents>
              </Flex>
            </>
          )}
        </Flex>
      </FloatingContainer>
    </>
  );
}
